export default __webpack_public_path__ + "static/N0075-e296d2ba9ba584853165555dd545abb7.png";